import { Minus, Plus } from "lucide-react";

export default function Counter({ value, onChange, min = 0, max = 99, testId, plusLabel }) {
  const atMax = value >= max;
  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <button
        type="button"
        data-testid={`${testId}-minus`}
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        className="w-8 h-8 rounded-lg bg-slate-100 text-navy flex items-center justify-center disabled:opacity-30 active:scale-90 transition hover:bg-amber-100"
      >
        <Minus className="w-4 h-4" />
      </button>
      <span className="w-10 text-center font-heading font-bold text-navy text-sm" data-testid={`${testId}-value`}>
        {atMax && plusLabel ? plusLabel : value}
      </span>
      <button
        type="button"
        data-testid={`${testId}-plus`}
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={atMax}
        className="w-8 h-8 rounded-lg bg-navy text-[#F5B301] flex items-center justify-center disabled:opacity-30 active:scale-90 transition"
      >
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
}
